import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class StatusAcao extends React.Component {
  render() {
    return <Lookup clearable={false} labelKey="descricao" valueKey="id" url="/StatusAcaoLookup" {...this.props} />;
  }
}

export default StatusAcao;
